var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RegistrationWithPD',{attrs:{"tournament-id":_vm.tournamentId}})
}
var staticRenderFns = []

export { render, staticRenderFns }